import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  SearchBar } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';

import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const BrokersList = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const [totalcount, setTotalcount] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  async function onUpdatestatus(indexval,ischecked)
  {
	let bodycontent = {
		broker_id : orders[indexval].id,
		status : ischecked
	}
	let products = await sendNetworkRequest('/admin/updatebrokerstatus', {}, bodycontent,true)
	
	fetchallbrokers("")
    
  }
  async function fetchallbrokers(searchtext)
  {
    let bodycontent = {
      searchtext,
      page: page * rowsPerPage,
      limit: rowsPerPage
  }
    let response = await sendNetworkRequest('/admin/getbroker', {}, bodycontent,false)
    setTotalcount(response.brokers.count)
    if(page > 0)
    {
      setOrders([...orders,...response.brokers?.rows])

    }else{
      setOrders(response.brokers?.rows)

    }
  }
  function onPageChange(page)
  {
    setPage(page)
  }
  function onPageLimit(limit)
  {
    setRowsPerPage(limit)
  }
  function applysearch(searchcontent)
  {
    setPage(0)
    fetchallbrokers(searchcontent)
  }
  useEffect(() => {
  


    fetchallbrokers()
  }, [page,rowsPerPage]);

  return (
    <Page
      className={classes.root}
      title="Survey"
    >
      <Header />
      <SearchBar onSearch={applysearch}/>
      <Results
        className={classes.results}
        orders={orders} //
        totalcount={totalcount}
        onPageChange={onPageChange}
        onStatusupdate={onUpdatestatus}
        onPageLimit={onPageLimit}
      />
     
    </Page>
  );
});

export default BrokersList;
